import * as Yup from 'yup';
import { getRequest, postRequest } from '../../services/httpService';

export interface Department {
  id: number;
  name: string;
  is_active: boolean;
}

export interface ClinicInfoFormData {
  name: string | null,
  code: string | null,
  description: string | null,
  phone: string | null,
  website: string | null,
  email: string | null,
  area: string | null,
  city: string | null,
  country: string | null,
  landmark: string | null,
  line_1: string | null,
  line_2: string | null,
  pincode: string | null,
  state: string | null,
  tin_no: string | null,
  gst_no: string | null,
  fax_no: string | null,
  licence_no: string | null,
  regitration_no: string | null,
  establishment_no: string | null,
  pan_no: string | null,
  cluster: string | null,
  server: string | null,
  database: string | null
  is_active?: boolean;
  id?: number,
  departments?: Department[];
}
export interface ClinicListResponse {
  objects: ClinicInfoFormData[];
  meta?: {
    total_count: number;
    limit?: number;
    offset?: number;
    next?: string | null;
    previous?: string | null;
  };
}

export interface Clinic {
  id: number;
  name: string;
} 

export interface DepartmentResponseItem {
  id: number;
  name: string;
  is_active: boolean;
}


export const initialClinicFormValues: ClinicInfoFormData = {
  name: '',
  code: '',
  description: '',
  phone: '',
  website: '',
  email: '',
  area: '',
  city: '',
  country: '',
  landmark: '',
  line_1: '',
  line_2: '',
  pincode: '',
  state: '',
  tin_no: '',
  gst_no: '',
  fax_no: '',
  licence_no: '',
  regitration_no: '',
  establishment_no: '',
  pan_no: '',
  cluster: '',
  server: '',
  database: ''
};




export const validationSchema = Yup.object({
  name: Yup.string().required('Clinic Name is required'),
  code: Yup.string()
    .required('')
    .matches(/^[a-zA-Z0-9]+$/, 'Code must be alphanumeric'),
  description: Yup.string().required('Description is required'),
  email: Yup.string().required().email('Invalid email'),
  phone: Yup.string()
    .required('')
    .matches(/^\d{12}$/, 'Mobile No. must be 12 digits')
    .matches(/^[0-9]+$/, 'Mobile No. must be numeric'),
  country: Yup.string().required('Country is required'),
  state: Yup.string().required('State is required'),
  city: Yup.string().required('City is required'),
  line_1: Yup.string().required('Address Line 1 is required'),
  line_2: Yup.string().nullable(),
  pincode: Yup.string().required('Pin/Zip Code is required'),
  tin_no: Yup.string().nullable(),
  gst_no: Yup.string().nullable(),
  fax_no: Yup.string().nullable(),
  cluster: Yup.string().nullable(),
  server: Yup.string().nullable(),
  database: Yup.string().nullable(),
  licence_no: Yup.string().nullable(),
  regitration_no: Yup.string().required('Clinic Registration No. is required'),
  establishment_no: Yup.string().nullable(),
  pan_no: Yup.string().nullable(),
});

// Get clinic list AND search clinic by name with pagination
export async function getClinicList(
  name: string,
  limit = 10,
  offset = 0
): Promise<ClinicListResponse> {
  const q = (name ?? '').trim();
  const params = new URLSearchParams();
  params.set('limit', String(limit));
  if (offset > 0) params.set('offset', String(offset));
  if (q) params.set('name__icontains', q);

  const url = `clinics/?${params.toString()}`;
  return getRequest<ClinicListResponse>(url, { responseType: 'json' });
}

// add/create clinic

export function addClinic(payload: ClinicInfoFormData): Promise<Clinic> {
  return postRequest('/clinics/', payload, { responseType: 'json' });
}

// get the clinic details by id
export function ClinicDetailsById(id: number | string): Promise<ClinicInfoFormData> {
  const url = `clinics/${id}`;
  return getRequest(url, { responseType: 'json' });
}

// get the department List by Clinic Id


export function getDepartmentList(): Promise<DepartmentResponseItem[]> {
  const url = 'departments/active-masters/';
  return getRequest(url, { responseType: 'json' });
}

// get the cities list by country and state
export function getCityList(country: string, state: string): Promise<{ data: string[] }> {
  const requestBody = JSON.stringify({ country: country , state: state });

  return postRequest('https://countriesnow.space/api/v0.1/countries/state/cities', requestBody, { responseType: 'json' });

}




